import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function XIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L5.49 21.75H2.18l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.085 4.126H5.117z" />
    </SvgIcon>
  );
}
